import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-building",
  "use": "icon-building-usage",
  "viewBox": "0 0 48.002 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48.002 48\" id=\"icon-building\">\r\n  <path id=\"icon-building_building\" d=\"M48,48H0V44H48Zm-2-6H2V40H46ZM12,38H4V24a2,2,0,0,1,0-4h8a2,2,0,0,1,0,4Zm16,0H20V24a2,2,0,0,1,0-4h8a2,2,0,0,1,0,4Zm16,0H36V24a2,2,0,0,1,0-4h8a2,2,0,0,1,0,4ZM24,0,0,18H48L24,0Zm0,6a4,4,0,1,1-4,4A4,4,0,0,1,24,6Z\" fill=\"currentColor\" fill-rule=\"evenodd\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol